import type { MouseEvent } from 'react';

import { openExternal, type OutboundMeta } from '@todo/core/open-external';

import css from './book-link.module.css';

// The affiliate CTA. A real <a href> for crawlers and no-JS (rel="sponsored
// nofollow"), but a click goes through openExternal — the one place the Umami
// `affiliate-click` event is sent (root AGENTS.md, "Outbound affiliate-click
// tracking").
export function BookLink({ url, meta, label }: { url: string; meta: OutboundMeta; label: string }) {
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    openExternal(url, meta);
  };

  return (
    <a href={url} target="_blank" rel="noopener noreferrer sponsored nofollow" onClick={onClick} className={css.button}>
      {label}
    </a>
  );
}
